// app协议路由
export default [
  {
    path: '/agreement',
    name: 'agreement',
    component: () =>
      import(/* webpackChunkName: "agreement" */ '@/views/agreement/index.vue')
  },
  {
    path: '/agreementImg',
    name: 'agreementImg',
    component: () =>
      import(
        /* webpackChunkName: "agreementImg" */ '@/views/agreement/indexImg.vue'
      )
  }
]
